/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, October 5th 2021, 7:43:40 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { Fragment } from "react";
import { ProgressWrapper, EmptyListWrapper } from "ui-widgets";
import { APIErrorWrapper, APIErrorWrapperProps } from "ui-widgets/wrappers/ErrorWrapper";
import { ProgressWrapperProps } from "ui-widgets/wrappers/ProgressWrapper";
import { EmptyListWrapperProps } from "ui-widgets/wrappers/EmptyListWrapper";

export type APIListProgressWrapperProps<T> = Partial<ProgressWrapperProps> &
  APIErrorWrapperProps &
  EmptyListWrapperProps<T> & {
    showMessageWhenEmpty?: boolean;
  };

export const APIListProgressWrapper = <T,>({
  showLoader,
  loaderType,
  isAPIError,
  showMessageWhenEmpty = true,
  errorMessage = null,
  httpResponseStatusCode = null,
  noDataMessage = null,
  items,
  children = null,
  ...props
}: APIListProgressWrapperProps<T>) => {
  return (
    <ProgressWrapper showLoader={showLoader} loaderType={loaderType} {...props}>
      <APIErrorWrapper
        isAPIError={isAPIError}
        errorMessage={errorMessage}
        httpResponseStatusCode={httpResponseStatusCode}
      >
        {showMessageWhenEmpty ? (
          <EmptyListWrapper items={items} noDataMessage={noDataMessage}>
            {children}
          </EmptyListWrapper>
        ) : (
          <Fragment>{children}</Fragment>
        )}
      </APIErrorWrapper>
    </ProgressWrapper>
  );
};

export type APIItemDisplayWrapperProps = Partial<ProgressWrapperProps & APIErrorWrapperProps>;

export const APIItemDisplayWrapper = ({
  showLoader,
  isAPIError,
  httpResponseStatusCode,
  errorMessage = null,
  children = null,
  ...props
}: APIItemDisplayWrapperProps) => {
  return (
    <ProgressWrapper showLoader={showLoader} {...props}>
      <APIErrorWrapper
        isAPIError={isAPIError}
        errorMessage={errorMessage}
        httpResponseStatusCode={httpResponseStatusCode}
      >
        {children}
      </APIErrorWrapper>
    </ProgressWrapper>
  );
};
